import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ISlimScrollOptions } from 'ng2-slimscroll';

import {
  MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck
} from './../../shared/message.event';

import { UtilityFunctions } from '../../shared/utility-functions';

@Component({
  selector: 'app-vendor-profile',
  templateUrl: './vendor-profile.component.html',
  styleUrls: ['./vendor-profile.component.css'],
  providers: [MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck]
})
export class VendorProfileComponent implements OnInit {

  private vendor;
  private uiSetting;
  private height;
  private scrollOptions: ISlimScrollOptions;
  private utilityFunctions = new UtilityFunctions;
  constructor(public router : Router, private openFrameEvent: OpenFrameEvent, private messageEvent: MessageEvent, private signInEvent: SignInEvent, private hiddenFooter: HiddenFooter, ) { 
    this.uiSetting = {
            'windowHeight': window.innerHeight,
            'topNav': 56,
            'midNav': 45,
            'footer': 35,
            'container': 75
        };
      this.scrollOptions = {
           barBackground: "#343a40", barOpacity: "0.6", position: "right",
           barWidth: "6", barBorderRadius: "5",barMargin:"1px 1px",gridBackground:"#adb5bd",gridOpacity:"1",gridWidth:"4",gridBorderRadius:"10",gridMargin:"1px 2px"
        };
        
        this.height = 0;
        // calculating height of current frame
        this.height = (this.uiSetting.windowHeight - (this.uiSetting.topNav + this.uiSetting.midNav + this.uiSetting.container + this.uiSetting.footer)) + 'px';
  }
  private shouldSlide: boolean = false;
  ngOnInit() {
    if (localStorage.getItem('vendor')) {
      this.emitOpenFrameEvent();
      this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    }
    this.registerTypeBroadcast();
    this.emitTypeBroadcast();
  }
  emitOpenFrameEvent() {
    this.openFrameEvent.fire(false);
  }
  /**
* while menu slide left to right as well as we shift header, footer and body too like menu by broadcaster  
*/

  registerTypeBroadcast() {
    this.messageEvent.on()
      .subscribe(message => {
        this.shouldSlide = message;
      });
  }

  /**
 * function show menu at facility page by broadcaster
 */

  emitTypeBroadcast() {
    let isShow = {
      privacypolicy: true,
      support: false,
      footer: 'block'
    };
    this.signInEvent.fire('block');
    this.hiddenFooter.fire(isShow);
  }

  /**
     * Redirecting to member page
     */

    homeScreen() {
        this.utilityFunctions.homeScreen(this);
    }
}



// WEBPACK FOOTER //
// ./src/app/authentication/vendor-profile/vendor-profile.component.ts